"use client";

import { useNavigationItems } from "@/context/NavigationItemsContext";
import { useEffect } from "react";

export default function NavigationUpdater({ items }: { items: { label: string; href: string }[] }) {
    const { setItems, reset } = useNavigationItems();

    useEffect(() => {
        setItems(items);
        return () => {
            reset();
        };
    }, [items, setItems, reset]);

    return null;
}
